/**
 * @generated SignedSource<<6de0fd57572d25b2b67bbf9452e6a785>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfilePreviewRelayContent_reportingLines$data = {
  readonly reportingLines: {
    readonly __typename: "KnowledgeDiscoveryReportingLines";
    readonly managers: ReadonlyArray<{
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    }>;
    readonly peers: ReadonlyArray<{
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    }>;
    readonly reports: ReadonlyArray<{
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    }>;
    readonly user: {
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "UserProfilePreviewRelayContent_reportingLines";
};
export type UserProfilePreviewRelayContent_reportingLines$key = {
  readonly " $data"?: UserProfilePreviewRelayContent_reportingLines$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelayContent_reportingLines">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "picture"
      },
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aaid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "siteId"
    }
  ],
  "kind": "Fragment",
  "name": "UserProfilePreviewRelayContent_reportingLines",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "aaid",
          "variableName": "aaid"
        },
        {
          "kind": "Variable",
          "name": "orgId",
          "variableName": "orgId"
        },
        {
          "kind": "Variable",
          "name": "siteId",
          "variableName": "siteId"
        }
      ],
      "kind": "LinkedField",
      "name": "reportingLines",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "managers",
              "plural": true,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "reports",
              "plural": true,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "peers",
              "plural": true,
              "selections": (v0/*: any*/)
            }
          ],
          "type": "KnowledgeDiscoveryReportingLines"
        }
      ]
    }
  ],
  "type": "KnowledgeDiscoveryQueryApi"
};
})();

(node as any).hash = "e70af5b531644ace6e8e4ed27953bb2e";

export default node;
